import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

/** Whether the event target is an editable field (so Cmd+K is left alone). */
function isEditableTarget(el: EventTarget | null): boolean {
  if (!el || !(el instanceof HTMLElement)) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
}

/**
 * Registers the global Cmd/Ctrl+K shortcut to open the search page.
 *
 * This lives at the app shell level (not inside the search UI) so the shortcut
 * survives independently of any search component being mounted — the old
 * listener was bound to the now-removed modal.
 */
export function useGlobalSearchShortcut(): void {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: KeyboardEvent): void => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        if (isEditableTarget(e.target)) return;
        e.preventDefault();
        navigate('/search');
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate]);
}
